import React from 'react'
import Helmet from 'react-helmet'
import Layout from '../components/layout'
import PageHeader from '../components/PageHeader'
import BackHome from '../components/BackHome'
import regulamin from '../assets/attachements/REGULAMIN.pdf'
import zalacznik1 from '../assets/attachements/Załącznik nr 1 do REGULAMINU.pdf'
import zalacznik2 from '../assets/attachements/Załącznik nr 2 do REGULAMINU.pdf'
import zalacznik3 from '../assets/attachements/Załącznik nr 3 do REGULAMINU.pdf'
import { useFirebase } from "gatsby-plugin-firebase"


const Formularze = (props) => {
    useFirebase(firebase => {
        firebase
          .analytics()
          .logEvent("visited_formularze")
      }, [])  
    
    return (
    <Layout>
        <Helmet>
            <title>Pliki do pobrania - Uczelnie Szkołom – o finansach z NBP</title>
            <meta name="description" content="Pliki do pobrania" />
        </Helmet>

        <PageHeader headerText="Pliki do pobrania"/>

        <div id="main" className="alt">
            <section id="one">
                <div className="inner">
                    <ul>
                        <li><a href={regulamin}>Regulamin Projektu</a></li>
                      </ul>
                       <p>Po otrzymaniu informacji o zakwalifikowaniu do Projektu, zostaną Państwo poproszeni o uzupełnienie poniższych formularzy:</p> 
                      <ul>
                        <li><a href={zalacznik1}>Załącznik nr 1 do Regulaminu</a></li>
                        <li><a href={zalacznik2}>Załącznik nr 2 do Regulaminu</a></li>
                        <li><a href={zalacznik3}>Załącznik nr 3 do Regulaminu</a></li>
                    </ul>
                </div>
            </section>

            <BackHome />
        </div>
    </Layout>
    )
}

export default Formularze